export default __webpack_public_path__ + "static/media/generator.8b4cd6b9.png";